import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-au-react-components';

const StyledHeroBannerMultiple = styled.div`
	@media (min-width: 576px) {
		margin: -10px;
	}

	> div {
		@media (min-width: 576px) {
			padding: 10px;
		}

		@media (max-width: 575px) {
			margin-bottom: 16px;
		}
	}

	&.length-4 > div,
	&.length-5 > div {
		@media (min-width: 576px) and (max-width: 991px) {
			flex-basis: 50%;
		}
	}

	&.length-6 > div {
		${EmotionBreakpoint('notDesktop')} {
			flex-basis: 50%;
		}
	}
`;

function HeroBannerMultiple({ props: { images } }) {
	return (
		<div className='container'>
			<StyledHeroBannerMultiple
				className={
					'd-sm-flex justify-content-center align-items-center flex-wrap flex-equal length-' +
					images.length
				}
			>
				{images.map((image, index) => {
					let {
						fields: {
							description,
							title,
							file: { url },
						},
					} = image;
					let content = (
						<img
							src={url}
							alt={title}
							title={title}
							className='d-inline-block mw-100'
						/>
					);

					if (description) {
						content = (
							<a className='d-block' href={description}>
								{content}
							</a>
						);
					}

					return <div key={index}>{content}</div>;
				})}
			</StyledHeroBannerMultiple>
		</div>
	);
}

export default HeroBannerMultiple;
